import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Iter-46at: Compact legal footer mounted app-wide (via <AppChrome /> in
 * App.js). Renders on public and authenticated routes alike so the compliance
 * links (Terms, Refund, Privacy, Cookies) are visible on every page.
 *
 * Intentionally minimal — no marketing chrome, no social links; those belong
 * on the landing page. The role here is legal-visibility only.
 */
export const GlobalFooter = () => {
  const year = new Date().getFullYear();

  const openCookiePrefs = (e) => {
    e.preventDefault();
    // Re-open the consent banner in "manage" mode. The banner reads this
    // localStorage flag on mount and unsets it after handling.
    try {
      localStorage.setItem('ss_cookie_consent_reopen', '1');
    } catch (_) { /* private-mode fallback: just navigate to the policy */ }
    window.dispatchEvent(new Event('ss:reopen-cookie-prefs'));
  };

  return (
    <footer
      className="border-t bg-background/60 backdrop-blur-sm text-xs text-muted-foreground print:hidden"
      data-testid="global-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
          <span>© {year} Borrow A Geek Limited t/a StudioScheduler.</span>
          <span className="hidden sm:inline">·</span>
          <span>Registered in Ireland.</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1" aria-label="Legal">
          <Link
            to="/terms"
            className="hover:text-foreground transition-colors"
            data-testid="footer-terms-link"
          >
            Terms &amp; Conditions
          </Link>
          <Link
            to="/refund-policy"
            className="hover:text-foreground transition-colors"
            data-testid="footer-refund-link"
          >
            Refund Policy
          </Link>
          <Link
            to="/privacy"
            className="hover:text-foreground transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </Link>
          <Link
            to="/cookies"
            className="hover:text-foreground transition-colors"
            data-testid="footer-cookies-link"
          >
            Cookie Policy
          </Link>
          <button
            type="button"
            onClick={openCookiePrefs}
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline"
            data-testid="footer-cookie-prefs-btn"
          >
            Cookie preferences
          </button>
        </nav>
      </div>
    </footer>
  );
};

export default GlobalFooter;
